// extracted by mini-css-extract-plugin
export default {"suggestionsRow":"RAim0PwbKBCczLk1Noia","suggestionChip":"D4TLRpp4h8tuS1fK65tm","aiSparkleIconContainer":"LdJQMD0DTG4uYatJ_x9G"};